import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Users } from "lucide-react";

export default function DonationSettingsFields({ donationReceived, setDonationReceived, razorpayLink, setRazorpayLink, autoDonationTotal = 0, donorCount = 0, featured, setFeatured }) {
  const total = (parseFloat(donationReceived) || 0) + autoDonationTotal;
  return (
    <>
      <div>
        <Label htmlFor="donation-received">Manual Adjustment / Donation Received (₹)</Label>
        <Input
          id="donation-received"
          type="number"
          min="0"
          value={donationReceived}
          onChange={(e) => setDonationReceived(e.target.value)}
          data-testid="donation-received-input"
          className="mt-1.5 h-11"
        />
      </div>

      <div className="bg-amtm-bg border border-amtm-border rounded-xl p-3 text-sm space-y-1" data-testid="donation-breakdown">
        <div className="flex justify-between text-amtm-textMuted">
          <span>Auto-tracked via Razorpay</span>
          <span data-testid="donation-auto-tracked-amount">₹{autoDonationTotal.toLocaleString("en-IN")}</span>
        </div>
        <div className="flex justify-between text-amtm-textMuted">
          <span>Manual adjustments</span>
          <span data-testid="donation-manual-amount">₹{(parseFloat(donationReceived) || 0).toLocaleString("en-IN")}</span>
        </div>
        <div className="flex justify-between font-semibold text-amtm-text pt-1 border-t border-amtm-border">
          <span>Total received</span>
          <span data-testid="donation-total-amount">₹{total.toLocaleString("en-IN")}</span>
        </div>
        <div className="flex justify-between text-amtm-textMuted pt-1 border-t border-amtm-border">
          <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" /> Donors</span>
          <span data-testid="donation-donor-count">{donorCount}</span>
        </div>
      </div>

      <div>
        <Label htmlFor="razorpay-link">Razorpay Payment Link</Label>
        <Input
          id="razorpay-link"
          value={razorpayLink}
          onChange={(e) => setRazorpayLink(e.target.value)}
          placeholder="https://razorpay.me/@amtmindia"
          data-testid="razorpay-link-input"
          className="mt-1.5 h-11"
        />
      </div>

      {setFeatured && (
        <div className="flex items-center justify-between py-1">
          <div>
            <Label htmlFor="featured-toggle">Featured on Homepage</Label>
            <p className="text-xs text-amtm-textMuted mt-0.5">Shown in "Rescues that need you now" if also public, Under Care, and has a Goal Amount above.</p>
          </div>
          <Switch id="featured-toggle" checked={!!featured} onCheckedChange={setFeatured} data-testid="featured-toggle" />
        </div>
      )}
    </>
  );
}
